<template>
    <div id="poster">
        <el-form :model="loginModel" :rules="rules" label-width="70px" ref="refForm" class="login-container">

            <!-- <h3 class="login_title">用户登录</h3> -->

            <el-row>
                <div id="wxLogin" style="width:300px;">
                    <wxlogin :appid="appid" :scope="'snsapi_login'" :theme="'black'"
                        :redirect_uri="encodeURIComponent(redirectUri)" v-if="!qrcode_replace_url.length">
                    </wxlogin>

                    <img :src="qrcode_replace_url" width="300" v-else>
                </div>
                <div id="accountLogin" style="width:300px;">
                    <div class="login_title">账号登录</div>
                    <el-form-item label="账号" prop="user_no">
                        <el-input ref="elUserNo" v-model="loginModel.user_no" auto-complete="off" placeholder="请输入手机号码或邮箱地址">
                            <template v-if="loginModel.status === 'uninitialize'" #append>
                                <el-button :disabled="!canSend" @click="onSendCheckCode">获取验证码{{hint}}</el-button>
                            </template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="密码" prop="password">
                        <el-input type="password" v-model="loginModel.password" auto-complete="off" ></el-input>
                    </el-form-item>

                    <el-form-item label="确认密码" v-show="loginModel.status === 'uninitialize'" prop="confirm_password">
                        <el-input type="password" v-model="loginModel.confirm_password" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="验证码" v-show="loginModel.status === 'uninitialize'" prop="code">
                        <el-input v-model="loginModel.code" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-alert v-show="loginModel.status === 'uninitialize'" style="margin-bottom:10px" title="欢迎使用，新用户请初始化您的密码！" type="warning"></el-alert>

                    <el-form-item style="width: 100%">
                        <el-button type="text" @click="onResetPassword">忘记密码</el-button>
                        <el-button type="primary" @click="onLogin" style="width:100px; position:absolute; right:0px;">登录</el-button>
                    </el-form-item>
                </div>
            </el-row>
        </el-form>
    </div>
</template>
 
<script>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import wxlogin from 'vue-wxlogin';

import userService from '../../services/user.service'
import httpService from '../../services/http.service'
import { isPhoneNumber, isMailAddress } from '../../utils/common'

export default {
    name: "tw-login",
    components: {
        wxlogin
    },
    setup() {
        const refForm = ref(null)
        const elUserNo = ref('')
        const route = useRoute()
        const router = useRouter()

        const canSend = ref(true)
        const hint = ref('')

        // 开放平台网站应用appid
        const appid = process.env.VUE_APP_WAAPPID
        // 微信扫码回调地址
        const redirectUri = `${window.location.origin}${process.env.BASE_URL}login-passport`
        // 微信二维码替换图
        const qrcode_replace_url = window.location.origin === 'https://tinwayerp.com' ? '' : `${process.env.BASE_URL}img/qrcode_replace.png`

        const loginModel = reactive({
            status: 'ok', // 用户状态：ok（正常）、unfound（没有该账号）、uninitialize（还没初始化密码）
            user_no: '',
            password: '',
            confirm_password: '',
            code: ''
        })

        const rules = {
            user_no: [
                {
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('请输入手机号码或邮箱地址'));
                        } else {
                            const valid = isPhoneNumber(value) || isMailAddress(value)
                            if (valid) {
                                const optCheckAccount = { name: 'check-account', headers: { Authorization: ''  } }
                                httpService.post(optCheckAccount, {}, { user_no: value }).then(data => {
                                    loginModel.status = data
                                    callback();
                                }).catch(err => {
                                    ElMessage.info({
                                        showClose: true,
                                        message: err.message
                                    })
                                })
                            } else {
                                callback(new Error('请输入手机号码或邮箱地址'));
                            }
                        }
                    },
                    trigger: 'blur' 
                }
            ],
            password: [
                { validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入密码'))
                    } else {
                        if (loginModel.confirm_password) {
                            refForm.value.validateField('confirm_password')
                        }
                        callback()
                    }
                }, trigger: 'blur' }
            ],
            confirm_password: [
                { validator: (rule, value, callback) => {
                    // 正常用户不需要验校确认密码
                    if (loginModel.status === 'ok') {
                        callback()
                        return
                    }

                    if (value === '') {
                        callback(new Error('请再次输入密码'));
                    } else if (value !== loginModel.password) {
                        callback(new Error('两次输入密码不一致!'));
                    } else {
                        callback();
                    }
                }, trigger: 'blur' }
            ],
            code: [
                { validator: (rule, value, callback) => {
                    // 正常用户不需要验校验证码
                    if (loginModel.status === 'ok') {
                        callback()
                        return
                    }

                    if (value === '') {
                        callback(new Error('请输入验证码'))
                    } else {
                        callback();
                    }
                }, trigger: 'blur' }
            ]
        }

        const login = function() {
            const user = {
                user_no: loginModel.user_no,
                password: loginModel.password
            }
            userService.login(user.user_no, user.password, route.query.sob_no).then(() => {
                // router.push({ name: 'main' })
                // 不使用 router 跳转是为了能让页面刷新，因为需要 router/index.js 单元加载动态路由
                if (route.params.project_id) {
                    // 本地调试时路径带有项目ID
                    window.location.href = `${process.env.BASE_URL}${route.params.project_id}/main`
                } else {
                    // 服务器调试时每个项目单独运行，不需要项目ID
                    window.location.href = `${process.env.BASE_URL}main`
                }
            }).catch(err => {
                ElMessage.info({
                    showClose: true,
                    message: err.message
                })
            })
        }

        const onResetPassword = function() {
            router.push({ name: 'reset-password' })
        }

        const onLogin = function() {
            refForm.value.validate(valid => {
                if (valid) {
                    if (loginModel.status === 'uninitialize') {
                        userService.resetPassword(loginModel.user_no, loginModel.password, loginModel.code).then(() => {
                            login()
                        }).catch(err => {
                            ElMessage.info({
                                showClose: true,
                                message: err.message
                            })
                        })
                    } else {
                        login()
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }

        const onKeyDown = function(e) {
            if (e.code === 'Enter') {
                onLogin()
            }
        }

        const onSendCheckCode = function() {
            if (loginModel.user_no) {
                loginModel.type = ''
                if (isPhoneNumber(loginModel.user_no)) {
                    loginModel.type = 'phone'
                }
                if (isMailAddress(loginModel.user_no)) {
                    loginModel.type = 'mail'
                }

                if (loginModel.type) {
                    // 防止连续点击
                    canSend.value = false
                    let i = 60
                    hint.value = `(${i})`
                    var timingInterval = setInterval(() => {
                        i--;
                        hint.value = `(${i})`
                    }, 1000);
                    setTimeout(() => {
                        hint.value = ''
                        clearInterval(timingInterval)
                        canSend.value = true
                    }, 60000)

                    userService.sendCheckCode(loginModel.user_no).then(() => {
                        ElMessage.info({
                            showClose: true,
                            message: `验证码已发送到您的${loginModel.type === 'phone' ? '手机' : '邮箱' }，请注意查收`
                        })
                    }).catch(err => {
                        ElMessage.info({
                            showClose: true,
                            message: err.message
                        })
                    })
                } else {
                    ElMessage.info({
                        showClose: true,
                        message: `无效的手机号码或邮箱地址`
                    })
                }
            } else {
                ElMessage.info({
                    showClose: true,
                    message: `请录入手机号码或邮箱地址`
                })
            }
        }

        onMounted(() => {
            elUserNo.value.focus()
            document.addEventListener('keydown', onKeyDown, true)
        })

        onUnmounted(() => {
            document.removeEventListener('keydown', onKeyDown, true)
        })

        return {
            refForm,
            elUserNo,
            appid,
            redirectUri,
            loginModel,
            rules,
            onLogin,
            onResetPassword,
            onSendCheckCode, canSend, hint,
            qrcode_replace_url
        }
    }
}
</script>
 
<style scoped>
#poster {
    background: url("../../assets/img/eva.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
}
body {
    margin: 0px;
    padding: 0;
}

.login-container {
    border-radius: 10px;
    background-clip: padding-box;
    margin: 15% auto;
    width: 680px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    opacity: 0.93;
    box-sizing: content-box;
}

.login_title {
    margin: 0px auto 40px auto;
    text-align: center;
    /* color: #505458; */
    font-size: 20px;
    color: rgb(55, 55, 55);
}

@media screen and (max-width: 451px) {
    #poster {
        background: url("../../assets/img/eva_phone.jpg") no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        background-size: cover;
        position: fixed;
    }
    .login-container {
        border-radius: 10px;
        background-clip: padding-box;
        margin: 135px auto;
        width: 320px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
    }

    #wxLogin {
        display: none !important;
    }
}

#wxLogin {
    position: relative;
    display: inline-block;
    margin: 20px;
}

#accountLogin {
    display: inline-block;
    margin: 20px;
}

#wxLogin:after {
    content: '';
    width: 1px;
    top: -20px;
    bottom: -20px;
    right: -20px;
    position: absolute;
    background-color: #e6e6e6;
    background-image: -webkit-linear-gradient(top,#fff,#e6e6e6 10%,#e6e6e6 90%,#fff 100%);
}
</style>